/**
 * @deprecated behind the useDatoShortcutEnabledChartElements FF
 * This is a short term solution.
 * Eventually we want to move this into a product configurable service.
 */
export const shortcutSupportedFlows = [
  'planOUD',
  'planAUD',
  'planNicotine',
  'nicotineCessation',
  'planPregnancy',
  'planDepression',
  'planAnxiety',
  'planInsomnia',
  'planPTSD',
  'planOther1',
  'planOther2',
  'planOther3',
  'planOther4',
  'planOther5',
  'planOther6',
  'planOther7',
  'planOther8',
  'planOther9',
  'planOther10',
  'planOther11',
  'planOther12',
  'planOther13',
  'planOther14',
  'planOther15',
];
